import { c as _c } from "react/compiler-runtime";
import type { PersonalMissionMessageMessage } from '@module/types/centrifuge/personalMessageTypes';
function PersonalMissionModalContent(t0) {
  const $ = _c(9);
  const {
    personalMissionPayload
  } = t0;
  let t1;
  let t2;
  if ($[0] !== personalMissionPayload.data.message.data.message) {
    const messages = personalMissionPayload.data.message.data.message.split("\n");
    t1 = "mt-[-12px] mb-[-24px] text-center text-xl";
    t2 = messages.map(_temp);
    $[0] = personalMissionPayload.data.message.data.message;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== personalMissionPayload.data.message.data.title) {
    t3 = <div className="-mb-2 mt-6 w-full rounded-lg bg-[#EAEAF0] p-4 font-bold text-[#4D5153] text-[17px]"><p>{personalMissionPayload.data.message.data.title}</p></div>;
    $[3] = personalMissionPayload.data.message.data.title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <section className={t1}>{t2}{t3}</section>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp(message, index) {
  return <p key={index}>{message}</p>;
}
export default PersonalMissionModalContent;